import createBrowserHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';

// Create a history of your choosing (we're using a browser history in this case).
export const history = createBrowserHistory();

history.listen((location, action) => {
  window.scrollTo(0, 0);
});

export const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
  const store = createStore(
    rootReducer,
    undefined,
    composeEnhancers(
      applyMiddleware(
        sagaMiddleware,
        routerMiddleware(history)
      )
    )
  );

  return {
    store,
    persistor: persistStore(store)
  };
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/state/store.js